import { createContext, useContext } from 'react';
import { CALC_TEST_ID, RetirementCalculatorStep } from '../../tools/RetirementCalculator.const';
import { RetirementCalculatorLayoutContextModel } from '../../tools/RetirementCalculator.model';

const DEFAULT_CONTEXT: RetirementCalculatorLayoutContextModel = {
  titleId: '',
  step: RetirementCalculatorStep.BASIC_DATA,
  component: 'main',
  testId: CALC_TEST_ID,
};

export const RetirementCalculatorLayoutContext =
  createContext<RetirementCalculatorLayoutContextModel>(DEFAULT_CONTEXT);

export const useRetirementCalculatorLayout = () => useContext(RetirementCalculatorLayoutContext);
